import { render } from "./NavTabPane.vue?vue&type=template&id=9da56f9c"
import script from "./NavTabPane.vue?vue&type=script&lang=js"
export * from "./NavTabPane.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__